import type { IconSvgObject } from './types';

const VolumeLowIcon: IconSvgObject = [
  ["path", { d: "M9 8.5H6C4.89543 8.5 4 9.39543 4 10.5V13.5C4 14.6046 4.89543 15.5 6 15.5H9L16 20V4L9 8.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 9C19.6254 9.81968 20 10.8634 20 12C20 13.1366 19.6254 14.1803 19 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default VolumeLowIcon;
